import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './FormControl.module.scss';

const FormControl = ({ children, className, ...restProps }: HTMLAttributes<HTMLDivElement>) => (
  <div {...restProps} className={classNames(styles.form_control, className)}>
    {children}
  </div>
);

export default FormControl;
